import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../redux/features/auth/authSlice';
import bannerReducer from '../redux/features/banner/bannerSlice';
import lotteryReducer from '../redux/features/lottery/lotterySlice';
import ticketReducer from '../redux/features/ticket/ticketSlice';
import cartReducer from '../redux/features/cart/cartSlice';
import orderReducer from '../redux/features/order/orderSlice';
import inquiryReducer from '../redux/features/inquiry/inquirySlice';
import subscriptionReducer from '../redux/features/subscription/subscriptionSlice';
import winnerReducer from '../redux/features/winner/winnerSlice';
import resultReducer from '../redux/features/result/resultSlice';
import webxReducer from '../redux/features/webx/webxslice';
import walletReducer from '../redux/features/wallet/walletSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    banner: bannerReducer,
    lottery: lotteryReducer,
    ticket: ticketReducer,
    cart: cartReducer,
    order: orderReducer,
    inquiry: inquiryReducer,
    subscription: subscriptionReducer,
    winner: winnerReducer,
    result: resultReducer,
    webx: webxReducer,
    wallet: walletReducer,
  },
});

export default store;
